export default "__VITE_ASSET__DRdgqEVn__"